/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 32);
/******/ })
/************************************************************************/
/******/ ({

/***/ "0GyJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("uSTI");
module.exports = __webpack_require__("0GyJ");


/***/ }),

/***/ "ZDuo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _window = window,
    Translator = _window.Translator,
    $ = _window.$,
    Routing = _window.Routing,
    utils = _window.utils,
    NProgress = _window.NProgress,
    _ = _window._,
    vueForm = _window.vueForm;
exports.Translator = Translator;
exports.$ = $;
exports.Routing = Routing;
exports.utils = utils;
exports.NProgress = NProgress;
exports._ = _;
exports.vueForm = vueForm;

/***/ }),

/***/ "uSTI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _legacyToModulesAdapter = __webpack_require__("ZDuo");

document.addEventListener('DOMContentLoaded', function () {
  var passwordInput = document.getElementById('password');
  var toggleIcon = document.getElementById('toggle-password');

  if (!passwordInput || !toggleIcon) {
    return;
  }

  toggleIcon.addEventListener('click', function () {
    var isPasswordVisible = passwordInput.type === 'text';

    passwordInput.type = isPasswordVisible ? 'password' : 'text';
    toggleIcon.classList.toggle('fa-eye', isPasswordVisible);
    toggleIcon.classList.toggle('fa-eye-slash', !isPasswordVisible);
    toggleIcon.title = _legacyToModulesAdapter.Translator.trans(isPasswordVisible ? 'Show password' : 'Hide password');
  });
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// login.js